import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { IDropDownView } from "../interfaces/idropdowns";
import { DropDownsService } from "../services/dropdowns.service";

@Injectable()
export class DropDownsResolver implements Resolve<IDropDownView[]> {
    constructor(private dropDownsService : DropDownsService) {
    }

    resolve(route: ActivatedRouteSnapshot): Observable<IDropDownView[]> {
        return this.dropDownsService.getAll();
    }
}

